class Interview {
  ready() {}

  // Check when confirm meeting schedule
  checkSelectInterviewTime(event) {
    event.preventDefault()
    let fieldSubject = $('input#message_subject')
    let fieldBody    = $('textarea#message_body')
    let isOpenScheduleAgain = $('#message_schedule_again').is(':checked')
    let fieldSubject2       = $('input#message_subject2')
    let fieldBody2          = $('textarea#message_body2')
    let notSelectedStatus   = this.notSelectedStatus(event.currentTarget.closest('form'));
    if (!fieldSubject.val() || !fieldBody.val() || notSelectedStatus) {
      // Handle show errors message by js
      let htmlError  = `<div class="errors-message row mb-2">
                          <div class="col-12">
                            <div class="alert alert-danger text-center">
                              <p class="mb-1 h5"><b>${gon.views.shared.send_message_error_title}</b></p>`
      if (!fieldSubject.val()) {
        $(fieldSubject).parent().addClass('fieldWithErrors')
        htmlError += `<p class="mb-0">${gon.views.shared.message_error_subject}</p>`
      } else $(fieldSubject).parent().removeClass('fieldWithErrors')
      if (!fieldBody.val()) {
        $(fieldBody).parent().addClass('fieldWithErrors')
        htmlError += `<p class="mb-0">${gon.views.shared.message_error_body}</p>`
      } else $(fieldBody).parent().removeClass('fieldWithErrors')
      if (notSelectedStatus) {
        event.currentTarget.closest('form').querySelector('.application-status-group')?.classList?.add('fieldWithErrors')
        htmlError += `<p class="mb-0">${gon.views.shared.message_error_application_status}</p>`
      } else {
        event.currentTarget.closest('form').querySelector('.application-status-group')?.classList?.remove('fieldWithErrors')
      }
      htmlError += '</div></div></div>'
      $('div.errors-message').remove()
      $('div#message').prepend(htmlError)
      $('html, body').animate({ scrollTop: 0 }, 400)
    } else if (isOpenScheduleAgain && (!fieldSubject2.val() || !fieldBody2.val())) {
      // Handle error message2 by js
      let htmlError  = `<div class="errors-message2 row mb-2">
                          <div class="col-12">
                            <div class="alert alert-danger text-center">
                              <p class="mb-1 h5"><b>${gon.views.shared.send_message_error_title}</b></p>`
      if (!fieldSubject2.val()) {
        $(fieldSubject2).parent().addClass('fieldWithErrors')
        htmlError += `<p class="mb-0">${gon.views.shared.message_error_subject}</p>`
      } else $(fieldSubject2).parent().removeClass('fieldWithErrors')
      if (!fieldBody2.val()) {
        $(fieldBody2).parent().addClass('fieldWithErrors')
        htmlError += `<p class="mb-0">${gon.views.shared.message_error_body}</p>`
      } else $(fieldBody2).parent().removeClass('fieldWithErrors')
      htmlError += '</div></div></div>'
      $('div.errors-message2').remove()
      $('div#message2').prepend(htmlError)
      $('html, body').animate({ scrollTop: $('#div_schedule').offset().top }, 400)
    } else {
      let currentForm  = $(event.currentTarget).parents('form')
      let eventChecked = $('input.checkbox-event:checked')
      let scheduleTime = $('div.list-free-time-area')
      let useInterview = $('input.switch-hide-show-interview').is(':checked')
      let useReadjust  = $('input.interview-readjust').val() === 'true'
      let showCalendar = $('div#div-calendar').attr('style')
      let confirmArea  = $('div.interview-schedule-confirm-area')
      let disableArea  = $('div.interview-schedule-confirm-area.disable-area')
      let isNewScout   = $('input#scout_new').is(':checked')
      let scoutStatus  = $('input.scout-past:checked').attr('data-status')
      let applyStatus  = $('select#messages_message_member_application_status').val()
      if (isNewScout || scoutStatus === 'is_not_interested' || (applyStatus &&
          !['first_interview', 'second_interview', 'third_interview', 'forth_interview'].includes(applyStatus))) {
        this.checkSubmittable(currentForm)
      }
      /* DJ-3480 - commented
      else if ((useInterview || useReadjust) && !showCalendar) {
        alert(gon.views.shared.turn_off_interview)
      } */
      else if (confirmArea.length > 0 && disableArea.length === 0) {
        if (eventChecked.length === 0)
          alert(gon.views.shared.have_not_select_schedule)
        else if (eventChecked.length > 1)
          alert(gon.views.shared.select_one_schedule)
        else if (eventChecked.attr('data-accept') === 'false')
          alert(gon.views.shared.candidate_not_accept_schedule)
        else {
          let itvTime          = parseInt($('input.length-of-interview').val())
          let rowChecked       = $(eventChecked[0]).closest('tr.schedule-from-company')
          if (rowChecked) {
            let eventId        = $(eventChecked[0]).val()
            let fixStartHour   = $(eventChecked[0]).attr('data-start-hour')
            let fixStartMinute = $(eventChecked[0]).attr('data-start-minute')
            let fixEndHour     = $(eventChecked[0]).attr('data-end-hour')
            let fixEndMinute   = $(eventChecked[0]).attr('data-end-minute')
            let startHour      = rowChecked.find(`select#interview_${eventId}_from__4i`)
            let startMinute    = rowChecked.find(`select#interview_${eventId}_from__5i`)
            let endHour        = rowChecked.find(`select#interview_${eventId}_to__4i`)
            let endMinute      = rowChecked.find(`select#interview_${eventId}_to__5i`)
            if (new Date(0, 0, 0, startHour.val(), startMinute.val()) < new Date(0, 0, 0, fixStartHour, fixStartMinute) ||
                new Date(0, 0, 0, endHour.val(), endMinute.val()) > new Date(0, 0, 0, fixEndHour, fixEndMinute)) {
              alert(gon.views.shared.without_time_confirmed)
              this.resetTimeSelect(startHour, fixStartHour, startMinute, fixStartMinute, endHour, fixEndHour, endMinute, fixEndMinute)
            }
            else if (rowChecked.length > 0 && startHour.val() === endHour.val() && startMinute.val() === endMinute.val()) {
              alert(gon.views.shared.start_time_same_end_time)
              this.resetTimeSelect(startHour, fixStartHour, startMinute, fixStartMinute, endHour, fixEndHour, endMinute, fixEndMinute)
            }
            else if (new Date(0, 0, 0, endHour.val(), endMinute.val()) - new Date(0, 0, 0, startHour.val(), startMinute.val()) > itvTime * 60 * 1000) {
              let errorText = !window.location.pathname.split('/').includes('en') ? `${itvTime}分以下のスケジュールを選択してください` : `Please Select A Schedule Of ${itvTime} Minutes Or Less`
              alert(errorText)
            }
            else if (new Date(0, 0, 0, endHour.val(), endMinute.val()) < new Date(0, 0, 0, startHour.val(), startMinute.val())) {
              alert(gon.views.shared.end_time_greater_than_start_time)
              this.resetTimeSelect(startHour, fixStartHour, startMinute, fixStartMinute, endHour, fixEndHour, endMinute, fixEndMinute)
            }
            else this.checkSubmittable(currentForm)
          } else this.checkSubmittable(currentForm)
        }
      // DJ-3480 - changed
      } else if ((useInterview || useReadjust) && showCalendar && scheduleTime.children().length === 0) {
        // alert(gon.views.shared.select_min_3_schedule)
        if (confirm(gon.views.shared.no_event_was_set)) {
          this.checkSubmittable(currentForm)
        }
      } else this.checkSubmittable(currentForm)
    }
  }

  checkDateSettingBeforeTabClosed(form) {
    if (form.free_time_from_1i && !confirm(gon.views.shared.confirm_before_setting)) return false
    window.close()
  }

  checkSubmittable(form) {
    let displayInterview = form[0].display_interview
    let hasInterviewDate = form[0].free_time_from_1i
    if (displayInterview && displayInterview.value == 'false' && hasInterviewDate)
      if (!confirm(gon.views.shared.confirm_before_setting)) return false
    form.submit()

    // Remove scout schedule send
    if ($('#div_schedule').length > 0 && $('#div_schedule')[0].style.display == 'none') {
      $('#div_schedule').remove()
      $('#content_send_again').remove()
    }
  }

  resetTimeSelect(startHour, fixStartHour, startMinute, fixStartMinute, endHour, fixEndHour, endMinute, fixEndMinute) {
    startHour.val(fixStartHour)
    startMinute.val(fixStartMinute)
    endHour.val(fixEndHour)
    endMinute.val(fixEndMinute)
  }

  notSelectedStatus(form) {
    let scout_application_status = $('[name="messages_message[application_status]"]');
    let member_application_status = $('[name="messages_message[member_application_status]"]');
    if (scout_application_status.length == 0 && member_application_status.length == 0) return false;

    let formData = new FormData(form);
    let statusSelected;
    if (scout_application_status.length > 0) statusSelected = formData.get('messages_message[application_status]');
    if (member_application_status.length > 0) statusSelected = formData.get('messages_message[member_application_status]');

    return !statusSelected
  }
}

export default new Interview();
